


















import { Component, Vue, Watch } from "vue-property-decorator";
import Invoice from "@/components/invoice.vue"; // @ is an alias to /src

@Component({
  components: {
    Invoice,
  },
})
export default class Home extends Vue {}
